import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import useClickOutside from "../../../../hooks/useClickOutside";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  dropdownPanelSx,
  FilterCheckbox,
  PeopleSearchIcon,
  searchFieldSx,
  triggerSx,
} from "./customersFilterUiShared";

export default function CustomerToolbarFilterDropdown({ label, placeholder, options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => {
    setOpen(false);
    setSearchTerm("");
  });

  const filtered = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggle = (value) => {
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  return (
    <Box ref={wrapperRef} sx={{ position: "relative", display: "inline-block" }}>
      <Box sx={triggerSx} onClick={() => setOpen((o) => !o)}>
        <Typography sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter", fontWeight: 400 }}>
          {label}
        </Typography>
        <Dropdown
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0)",
            transition: "transform 0.2s",
            width: 16,
            height: 16,
          }}
        />
      </Box>
      {open && (
        <Box sx={dropdownPanelSx} style={{ height: label=== "Role" ? "180px" : "224px" }}>
          <Box sx={{ flexShrink: 0 }}>
            <TextField
              fullWidth
              autoFocus
              variant="outlined"
              placeholder={placeholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PeopleSearchIcon style={{ width: 16, height: 16, display: "block" }} />
                  </InputAdornment>
                ),
              }}
              sx={searchFieldSx}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              mt: 1,
              overflowY: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(0,0,0,0.2) transparent",
            }}
          >
            {filtered.map((opt) => {
              const checked = selected.includes(opt.value);
              return (
                <Box
                  key={opt.value}
                  onClick={() => toggle(opt.value)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 1.5,
                    py: 1,
                    borderRadius: "8px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#F9FAFA" },
                  }}
                >
                  <FilterCheckbox
                    checked={checked}
                    icon={<CheckboxUncheckedIcon />}
                    checkedIcon={<CheckboxCheckedIcon />}
                    disableRipple
                    onChange={() => toggle(opt.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <Typography sx={{ fontSize: 14, color: "#061522", fontFamily: "Inter" }}>
                    {opt.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
}
